import React, { useState } from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';

// One-time prompt for existing users who registered before the Terms of Use
// were introduced (new users accept at registration).
function TermsAcceptanceModal() {
  const { needsTermsAcceptance, acceptCurrentTerms, logout, isAuthenticated } = useAuth();
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  if (!isAuthenticated || !needsTermsAcceptance) {
    return null;
  }

  const handleAccept = async () => {
    setSubmitting(true);
    setError('');
    const ok = await acceptCurrentTerms();
    if (!ok) {
      setError('Could not record your acceptance. Please try again.');
    }
    setSubmitting(false);
  };

  return (
    <Modal show backdrop="static" keyboard={false} centered>
      <Modal.Header>
        <Modal.Title>Terms of Use</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}
        <p>
          We've introduced <a href="/terms" target="_blank" rel="noopener noreferrer">Terms of Use</a> covering
          community content: there is zero tolerance for objectionable content or abusive behavior,
          you can report any review, and you can block any user.
        </p>
        <p className="mb-0">Please accept the terms to continue using your account.</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={logout} disabled={submitting}>
          Log out
        </Button>
        <Button variant="primary" onClick={handleAccept} disabled={submitting}>
          {submitting ? 'Saving...' : 'I agree to the Terms of Use'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default TermsAcceptanceModal;
